import React, { useContext } from "react";

// AssetDownloadContext
import AssetDownloadContext from "core/AssetDownload/Context";

// auth
import { useAuth } from "frontend/hooks/useAuth";

// styles
import colors from "core/colors";
import { FooterStyled, SocialContainerStyled } from "./styles";

// components
import ShareSocials from "core/ShareSocials";
import BackLink from "./BackLink";

const Footer = () => {
    const {
        state: { asset, assetType, isReadyForDownload, assetDownloadConfig }
    } = useContext(AssetDownloadContext);

    const { isLoggedIn } = useAuth();

    if (!isLoggedIn || !isReadyForDownload) {
        return null;
    }

    const { getPermalinkPath } = assetDownloadConfig;

    return (
        <FooterStyled>
            <BackLink />
            <SocialContainerStyled>
                <ShareSocials
                    spaceBetweenIcons="0.8125rem"
                    creatorName={asset.creator.name}
                    imageType={assetType}
                    permalinkPath={getPermalinkPath(asset)}
                    socialIconHeight={28}
                    socialIconWidth={28}
                    socialIconColor={colors.primary.diamond}
                />
            </SocialContainerStyled>
        </FooterStyled>
    );
};

export default Footer;
